export default __webpack_public_path__ + "static/media/Fkey.9d3b906c.png";